import { cx } from '@mage-ui/styled-system/css';
import { navSubMenu, scrollbar } from '@mage-ui/styled-system/recipes';
import { NavItem } from '../nav-item/NavItem';

export const NavSubMenu = ({ data, ...props }) => {
  //possar inline flex focus
  return (
    <ul className={cx(navSubMenu(), scrollbar())} {...props}>
      {data
        ?.filter((item) => item?.fields?.title)
        .map((item) => (
          <li key={item?.meta?.key}>
            <NavItem data={item} level={2} />
          </li>
        ))}
    </ul>
  );
};
